
import { defineComponent, ref } from "vue";
import PublicPage from "@/views/public/PublicPage.vue";

export default defineComponent({
  name: "support-page",
  components: { PublicPage },
  setup() {
    // Parts are kept separate and joined only at click time, so the full
    // address never appears verbatim in the markup or bundle for scrapers.
    const emailUser = "hello";
    const emailDomain = "mays.app";
    const copied = ref(false);

    const copyEmail = async () => {
      const address = emailUser + String.fromCharCode(64) + emailDomain;
      try {
        await navigator.clipboard.writeText(address);
      } catch (_) {
        const ta = document.createElement("textarea");
        ta.value = address;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      copied.value = true;
      setTimeout(() => (copied.value = false), 2000);
    };

    return { emailUser, emailDomain, copied, copyEmail };
  },
});
